import { DarkWebPlatforms } from '@/utils/constants'
import { atom } from 'jotai'

// Create an atom to hold the exposure type
export const reportPlatformTabAtom = atom<DarkWebPlatforms>(DarkWebPlatforms.CRED_LEAKS)
